import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const routeTitles = {
  // New Dashboard Routes
  "/new/dashboard": "Dashboard",
  "/new/test-studio": "Test Studio",
  "/new/reports": "Reports",
  "/new/test-suites": "Test Suites",
  "/new/analytics": "Analytics",
  "/new/reports/history": "Execution History",
  "/new/dashboard/ResultStepPage": "Test Step History",
  "/new/mobile": "Mobile Automation",
  "/new/defect-analysis": "Defect Analysis",
  "/new/test-case-history": "Test Case History",
  "/new/api": "API",
  "/new/test-data": "Test Data",
  "/new/api-summary": "API Summary",
  "/new/help": "Help Center",
  "/new/test-case-report": "Test Case Report",
  "/new/settings": "Settings",

  // Old Dashboard Routes
  "/dashboard/app": "Dashboard",
  "/dashboard/recording": "Recording",
  "/dashboard/upload": "Upload",
  "/dashboard/createCollection": "Create Collection",
  "/dashboard/newcreateCollection": "Create Collection",
  "/dashboard/createTestCase": "Create Test Case",
  "/dashboard/repos": "Impact Analysis",
  "/dashboard/AdminPage": "Admin",
  "/dashboard/CoveragePage": "Coverage",
  "/dashboard/CoverageDashboard": "Coverage Dashboard",
  "/dashboard/UserPage": "User",
  "/dashboard/userExperience": "User Experience",
  "/dashboard/testData": "Test Data",
  "/dashboard/api": "API",
  "/dashboard/Reports": "Reports",
  "/dashboard/Test": "Test",
  "/dashboard/chatBot": "Chat Bot",
  "/LoginPage": "Login",
  "/SignUpPage": "Sign Up",
  "/ForgotPasswordPage": "Forgot Password",
  "/payment": "Payment",
  "/profile": "Profile",
  "/ranking": "Ranking",
  "/config": "Configuration",
};

const getTitleFromParams = (location) => {
  const searchParams = new URLSearchParams(location.search);
  const name = searchParams.get("name");
  const tcname = searchParams.get("tcname");
  const date = searchParams.get("date");

  if (tcname) {
    return `${tcname} - Test Case`;
  }

  if (name) {
    return `${name} - Test Suite`;
  }

  return null;
};

export const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Get the base path without any parameters
    const path = location.pathname.split("/").slice(0, 3).join("/");
    if (location.pathname.includes("/ResultStepPage/")) {
      document.title = routeTitles["/new/dashboard/ResultStepPage"] || "Nogrunt - Test Automation";
      return;
    }

    const paramTitle = getTitleFromParams(location);
    if (paramTitle) {
      document.title = paramTitle;
      return;
    }

    const title = routeTitles[path] || "Nogrunt - Test Automation";

    document.title = title;
  }, [location.pathname, location.search]);
};
